// extracted by mini-css-extract-plugin
export var container = "section-about-module--container--p7w6c";
export var contents = "section-about-module--contents--zT3Cp";
export var about = "section-about-module--about--AID1M";
export var description = "section-about-module--description--V9AVl";
export var usage = "section-about-module--usage--48UKf";
export var system_image = "section-about-module--system_image--1tmYq";
export var note = "section-about-module--note--Smn8-";